import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';

const ImageBlockWrapper = styled.div`
  width: 100%;
  height: auto;
  margin: 2rem 0;

  ${props =>
    props.textwidth &&
    css`
      max-width: 35.625rem;
      margin: 0;
    `};

  ${props =>
    props.moreSpacing &&
    css`
      margin: 5rem 0 4rem;

      @media screen and (max-width: 64rem) {
        margin-bottom: 2rem;
      }
    `};

  ${props =>
    props.inSidebar &&
    css`
      margin: 1.14rem 0;
    `};
`;

const Image = styled.img`
  display: block;
  max-width: 100%;
  width: 100%;
`;

const ImageText = styled.p`
  font-size: 0.875rem;
  font-weight: 300;
  margin-top: 13px;

  @media screen and (max-width: 64rem) {
    margin: 13px 1.5rem 0;
  }
`;

const BoldImageText = styled.strong`
  s: uppercase;
`;

const ImageBlock = ({
  index,
  src,
  alt,
  imageText,
  moreSpacing,
  inSidebar,
  textwidth
}) => {
  return (
    <ImageBlockWrapper
      moreSpacing={moreSpacing}
      inSidebar={inSidebar}
      textwidth={textwidth}
    >
      <LazyLoad offset={200}>
        <Image src={src} alt={alt} />
      </LazyLoad>
      {imageText && (
        <ImageText>
          {index !== undefined && (
            <BoldImageText>Fig. {`${index}`.padStart(2, '0')}.</BoldImageText>
          )}{' '}
          {imageText}
        </ImageText>
      )}
    </ImageBlockWrapper>
  );
};

ImageBlock.propTypes = {
  index: PropTypes.number,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imageText: PropTypes.string,
  moreSpacing: PropTypes.bool
};

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/components/ImageBlock.js